// DOM Helpers

export const element = (id) => document.getElementById(id);
